export const WEB3_CONNECT_MODAL_ID = "WEB3_CONNECT_MODAL_ID";
export const PREFERRED_PROVIDER_KEY = "WEB3_CONNECT_PREFERRED_PROVIDER";

export const INJECTED_PROVIDER_ID = "injected";

export const CONNECT_EVENT = "connect";
export const ERROR_EVENT = "error";
export const CLOSE_EVENT = "close";
